import React, { useEffect, useState } from "react";
import { DatePicker, TimePicker, Space } from "antd";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";
import {
  MOBILE_DATE_PICKER_PROPS,
  MOBILE_TIME_PICKER_PROPS,
} from "../IpEMR/Nurse/CareItems/nurseCareMobilePickerProps";

const toDayjs = (v) => (v ? dayjs(v) : null);

const combineDateTime = (datePart, timePart) => {
  if (!datePart) return null;
  let combined = dayjs(datePart);
  if (timePart) {
    const time = dayjs(timePart);
    combined = combined
      .hour(time.hour())
      .minute(time.minute())
      .second(time.second());
  } else {
    combined = combined.startOf("day");
  }
  return combined.toISOString();
};

const ClinicalFormDateTime = ({
  value,
  onChange,
  readOnly,
  size,
  placeholder = "Select date & time",
  style,
  getPopupContainer,
}) => {
  const isMobile = useIsMobile();
  const parsed = toDayjs(value);
  const [datePart, setDatePart] = useState(parsed);
  const [timePart, setTimePart] = useState(parsed);

  useEffect(() => {
    const next = toDayjs(value);
    setDatePart(next);
    setTimePart(next);
  }, [value]);

  const popupContainer = () => document.body;

  if (!isMobile) {
    return (
      <DatePicker
        showTime
        size={size}
        style={{ width: "100%", maxWidth: 260, ...style }}
        placeholder={placeholder}
        value={parsed}
        onChange={(d) => onChange(d ? d.toISOString() : null)}
        disabled={readOnly}
        getPopupContainer={getPopupContainer || popupContainer}
      />
    );
  }

  const handleDateChange = (nextDate) => {
    setDatePart(nextDate);
    if (!nextDate) {
      onChange(null);
      return;
    }
    onChange(combineDateTime(nextDate, timePart));
  };

  const handleTimeChange = (nextTime) => {
    setTimePart(nextTime);
    if (!nextTime && !datePart) {
      onChange(null);
      return;
    }
    const baseDate = datePart || dayjs();
    if (!datePart) {
      setDatePart(baseDate);
    }
    onChange(combineDateTime(baseDate, nextTime));
  };

  return (
    <Space
      direction="vertical"
      size={8}
      className="clinical-form-datetime-mobile"
      style={{ width: "100%" }}
    >
      <DatePicker
        size={size}
        style={{ width: "100%" }}
        placeholder="Select date"
        value={datePart}
        onChange={handleDateChange}
        disabled={readOnly}
        inputReadOnly
        {...MOBILE_DATE_PICKER_PROPS}
        getPopupContainer={popupContainer}
      />
      <TimePicker
        size={size}
        style={{ width: "100%" }}
        placeholder="Select time"
        value={timePart}
        onChange={handleTimeChange}
        disabled={readOnly}
        inputReadOnly
        {...MOBILE_TIME_PICKER_PROPS}
        getPopupContainer={popupContainer}
      />
    </Space>
  );
};

export default ClinicalFormDateTime;
